if (__SERVER__ && process.env.ENV !== 'aws') {
    module.exports = require('../src/settings.json'); // eslint-disable-line
} else {
    module.exports = undefined; // eslint-disable-line
}
